import { MediaEvent } from '../media.events';

export const MEDIA_UPLOAD_FILE_STATUS = {
  added: 'added',
  processing: 'processing',
  ready: 'ready',
  uploaded: 'uploaded',
  error: 'error',
  removed: 'removed',
} as const;

export const MEDIA_FILE_STATUS = {
  loading: 'loading',
  loaded: 'loaded',
  error: 'error',
};

export type MediaUploadFileStatus = keyof typeof MEDIA_UPLOAD_FILE_STATUS;
export type MediaFileStatus = keyof typeof MEDIA_FILE_STATUS;

export type MediaFileId = string;
export type ServerFileId = string;

type BaseFile = {
  id: MediaFileId;
  serverId?: ServerFileId;
  name: string;
  mimeType: string;
  extension?: string;
  status: MediaUploadFileStatus;
  mediaStatus: MediaFileStatus;
  file?: File;
  url?: string;
  error?: string;
};

type MediaFileTypeMap = {
  image: {};
  video: {
    duration?: number;
    poster?: string;
  };
  other: {};
};

export type MediaFile = Readonly<
  {
    [K in keyof MediaFileTypeMap]: BaseFile & {
      type: K;
    } & MediaFileTypeMap[K];
  }[keyof MediaFileTypeMap]
>;

export type MediaState = readonly MediaFile[];
export type MediaDispatch = (event: MediaEvent) => void;
export type MediaOnChange = (
  event: MediaEvent,
  state: MediaState
) => void | Promise<void>;
